<template>
  <ButtonBookmark :isActive="isBookmarked" @click="toggle()" data-lock-click />
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  //-------------------------------
  import { ButtonBookmark } from '@/Groups/Signals/private/imports/externalTemplates';
  //-------------------------------
  const props = defineProps({
    id: { type: Number }
  });
  const store = useStore();
  //-------------------------------
  const isBookmarked = computed(() => {
    const signal = store.getters["Signals/data"][props.id];
    return signal?.reactions?.bookmarked?.is_mine ?? false;
  });
  //-------------------------------
  const toggle = () => {
    store.dispatch("Signals/toggleFavouriteOptimistic", props.id);
  }
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>